(function () {
  function shortAddress(address) {
    if (!address) return "";
    return address.slice(0, 6) + "..." + address.slice(-4);
  }

  function setValue(selector, value) {
    document.querySelectorAll(selector).forEach(function (input) {
      input.value = value || "";
    });
  }

  function setText(selector, value) {
    document.querySelectorAll(selector).forEach(function (node) {
      node.textContent = value || "";
    });
  }

  async function connectWallet() {
    if (!window.ethereum || !window.ethereum.request) {
      window.dispatchEvent(new CustomEvent("crypto-checkout:error", { detail: "wallet_missing" }));
      return;
    }

    var accounts = await window.ethereum.request({ method: "eth_requestAccounts" });
    var address = accounts && accounts[0];
    if (!address) return;

    localStorage.setItem("checkout_wallet_address", address);
    setValue("[data-wallet-address-input]", address);
    setText("[data-wallet-address-label]", shortAddress(address));
    document.querySelectorAll("[data-wallet-status]").forEach(function (node) {
      node.dataset.connected = "true";
    });
  }

  function selectCurrency(value) {
    var available = Array.prototype.slice.call(document.querySelectorAll("[data-payment-currency]")).map(function (button) {
      return button.dataset.paymentCurrency;
    });
    if (available.indexOf(value) === -1) {
      value = "JPY";
    }

    localStorage.setItem("checkout_currency", value);
    setValue("[data-payment-currency-input]", value);
    document.querySelectorAll("[data-payment-currency]").forEach(function (button) {
      button.dataset.selected = button.dataset.paymentCurrency === value ? "true" : "false";
    });
  }

  function boot() {
    var savedWallet = localStorage.getItem("checkout_wallet_address");
    var savedCurrency = localStorage.getItem("checkout_currency") || "JPY";

    setValue("[data-wallet-address-input]", savedWallet);
    setText("[data-wallet-address-label]", shortAddress(savedWallet));
    selectCurrency(savedCurrency);

    document.querySelectorAll("[data-wallet-connect]").forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        connectWallet();
      });
    });

    document.querySelectorAll("[data-payment-currency]").forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        selectCurrency(button.dataset.paymentCurrency);
      });
    });
  }

  document.addEventListener("DOMContentLoaded", boot);
})();
